<template>
  <v-container
    fluid
    tag="section"
    class="privat-setting-modal"
  >
    <v-row justify="start">
      <v-dialog
        v-model="isShowModal"
        persistent
        max-width="440"
      >
        <v-card>
          <v-card-title class="headline">
            Добавить Настройки
            <v-btn
              color="green darken-1"
              text
              class="close-btn"
              @click="closeModal()"
            >
              <v-icon>close</v-icon>
            </v-btn>
          </v-card-title>
          <v-card-text>
            <form>
              <!-- Id -->
              <v-col
                cols="12"
                class="pb-0"
              >
                <v-text-field
                  v-model="formData.api_id"
                  v-validate="'required'"
                  :error-messages="errors.collect('id')"
                  label="Id"
                  data-vv-name="id"
                  validate-on-blur
                  required
                  color="purple darken-2"
                  clearable
                  prepend-icon="mdi-account-edit"
                />
              </v-col>

              <!-- Token -->
              <v-col
                cols="12"
                class="pb-0"
              >
                <v-textarea
                  v-model="formData.api_token"
                  v-validate="'required'"
                  :error-messages="errors.collect('token')"
                  label="Token"
                  data-vv-name="token"
                  validate-on-blur
                  required
                  color="purple darken-2"
                  clearable
                  prepend-icon="mdi-account-edit"
                />
              </v-col>

              <v-col
                cols="12"
                class="py-0 my-4 text-center"
              >
                <v-btn
                  class="mr-0"
                  color="#0051ff"
                  :disabled="errors.any() || isSendFormCompanyBankAccountSettings"
                  @click="save"
                >
                  Сохранить
                </v-btn>
              </v-col>
            </form>
          </v-card-text>
        </v-card>
      </v-dialog>
    </v-row>
  </v-container>
</template>

<script>
  import { mapGetters } from 'vuex'

  export default {
    name: 'AddPrivatBankSettingModal',
    props: {
      isShowModal: {
        type: Boolean,
        default: false,
      },
      form: {
        type: Object,
        required: true,
      },
    },

    data () {
      return {
        formData: {},
      }
    },

    computed: {
      ...mapGetters('companyBankAccountSettings', ['isSendFormCompanyBankAccountSettings']),
    },

    created () {
      this.formData = Object.assign({}, this.form)
      this.formData.bank_alias = 'privat'
    },

    methods: {
      closeModal () {
        this.$emit('closeModal')
      },

      save () {
        this.$validator.validateAll().then(validated => {
          if (!validated) {
            return
          }

          this.$emit('save', Object.assign({}, this.formData))
        })
      },
    },
  }
</script>

<style scoped>

</style>
